module.exports = __webpack_public_path__ + "img/frame-browser-foujita-long-en.282cd8ee.jpg";